import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/landing/pageContext';

type RelatedArticle = {
	articleTitle: string;
	slug: string;
};

type Category = {
	name: string | null;
	slug: string;
};

type Result = ModelHookResult<
	{ relatedArticles: readonly RelatedArticle[]; categories: readonly Category[] },
	{ trackSeeAllClick: () => void; trackCategoryChipClick: (categorySlug: string) => void }
>;

export function useRelatedArticles(): Result {
	const {
		data: { relatedArticles, categories },
	} = usePetitionGuidesPageData();

	const track = useTracking();

	return {
		data: {
			relatedArticles,
			categories,
		},
		actions: {
			trackSeeAllClick: () => {
				void track('petition_guides_landing_page_see_all_click');
			},
			trackCategoryChipClick: (categorySlug: string) => {
				void track('petition_guides_landing_page_category_chip_click', { category_slug: categorySlug });
			},
		},
	};
}
